export default "__VITE_ASSET__CInQ2OHK__"